import { render } from "./InvestBlockRWA.vue?vue&type=template&id=14657614&scoped=true"
import script from "./InvestBlockRWA.vue?vue&type=script&lang=js"
export * from "./InvestBlockRWA.vue?vue&type=script&lang=js"

import "./InvestBlockRWA.vue?vue&type=style&index=0&id=14657614&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14657614"]])

export default __exports__